import { useEffect, useState } from "react";
import { clearToken, getMe, getToken } from "../api";

/**
 * Hook de autenticação e sessão.
 * Restaura sessão ao montar (token + getMe); expõe user, setUser, checkingAuth e logout.
 */
function useAuth() {
  const [checkingAuth, setCheckingAuth] = useState(true);
  const [user, setUser] = useState(null);

  useEffect(() => {
    const restoreSession = async () => {
      const token = getToken();

      if (!token) {
        setCheckingAuth(false);
        return;
      }

      try {
        const me = await getMe();
        setUser(me);
      } catch {
        clearToken();
        setUser(null);
      }

      setCheckingAuth(false);
    };

    restoreSession();
  }, []);

  const logout = () => {
    clearToken();
    setUser(null);
  };

  return { user, setUser, checkingAuth, logout };
}

export default useAuth;
